<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal
        :show.sync="modals.successModal"
        :message="message"
        :title="title"
      />
      <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>{{ title }}</h1>
            <p>{{ message }}</p>
            <base-button class="btn-primary" @click="redirect()"
              >Done</base-button
            >
          </div>
        </div>
      </modal>
      <!-- v-if="status == 7" -->
      <div class="row">
        <div class="col-lg"></div>

        <div class="col-lg-4">
          <card class="card-eprf" style="height: 630px">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WEIGHT BRIDGE RECEIPT
                </p>
              </div>
            </div>

            <p class="newtitle" v-if="displayflag">
              Choose File from Your Desktop
            </p>
            <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
              Please upload weight bridge receipt
            </p>
            <div class="fileinput" v-if="displayflag">
              <label
                for="wb-upload"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>

              <div
                class="d-flex justify-content-center spinner"
                v-if="uploadload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="wb-upload"
                type="file"
                ref="signeddo"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onTerminatedChange"
              />
            </div>
            <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
            <div v-if="uploadload == false" class="">
              <div
                v-for="(filee, index) in allTeminatedPTW"
                :key="index"
                class="row"
              >
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg text-left">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="displayflag">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeSignedDO(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <card class="card-eprf" style="height: 630px">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  CONSIGNMENT NOTE
                </p>
              </div>
            </div>

            <p class="newtitle" v-if="displayflag">
              Choose File from Your Desktop
            </p>
            <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
              Please upload consignment note
            </p>
            <div class="fileinput" v-if="displayflag">
              <label
                for="cn-upload"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>

              <div
                class="d-flex justify-content-center spinner"
                v-if="labload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="cn-upload"
                type="file"
                ref="cn"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onLabChange"
              />
            </div>
            <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
            <div v-if="labload == false" class="">
              <div
                v-for="(filee, index) in allLabReport"
                :key="index"
                class="row"
              >
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg text-left">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="displayflag">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeLab(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg"></div>
      </div>
      
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            wide
            type="danger"
            @click.native="prevTab"
            class="btn-previous"
          >
            BACK
          </base-button>
          <base-button
            type="primary"
            wide
            class="btn-next"
            @click="review()"
            v-if="displayflag"
          >
            REVIEW
          </base-button>

          <base-button
            v-if="!displayflag"
            type="primary"
            wide
            class="btn-next"
            @click="nextTab"
          >
            NEXT
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle8 } from "vue-loading-spinner";
import StatusModal from "src/components/StatusModal.vue";
import swal from "sweetalert2";
import moment from "moment";
import { Table, TableColumn } from "element-ui";
import { Modal } from "src/components";

export default {
  components: {
    Circle8,
    StatusModal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },
  data() {
    return {
      positionid: "",
      uploadload: false,
      allTeminatedPTW: [
        {
          fileid: "0",
          filename: "ABC File",
          fileurl: "",
        },
      ],
      allLabReport: [],
      labload: false,
      message: "",
      title: "",
      modals: {
        successModal: false,
        submit: false,
      },
      status: "",
      displayflag: false,
      dis: false,
      dateselected: "",
      refno: "",
      vendorname: "",
      vendorphone: "",
      platenumber: "",
      drivername: "",
      driveric: "",
      tableDatas: [],
      // picture
      preoperation: [],
      duringoperation: [],
      postoperation: [],
      inspection: [],
      other: [],
      // docs
      ptw: [],
      ecaf: [],
      terminatedptw: [],
      labreport: [],
      weightreceipt: [],
      cn: [],
    };
  },
  methods: {
    completejob() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/complete"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.title = "JOB REQUEST COMPLETED";
            this.message = "Thank you";
            this.modals.submit = true;
          }
        });
    },
    review() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/review"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            // this.getData();
            this.nextTab();
          }
        });
    },
    onTerminatedChange(e) {
      this.uploadload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/weight-bridge",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.uploadload = false;
            this.getData();
          }
        });
    },
    onLabChange(e) {
      this.labload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/consignment-note",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.labload = false;
            this.getData();
          }
        });
    },
    removeLab(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/document/consignment-note/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
                this.$refs.cn.value = "";

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    removeSignedDO(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/document/weight-bridge/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
                this.$refs.signeddo.value = "";
                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    backtolist() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/product/" +
            this.$route.params.refno +
            "/terminate_ptw/submit"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.successModal = true;
            console.log(response);

            setTimeout(() => {
              this.redirect();
            }, 1000);
          }
        });
    },
    redirect() {
      this.$router.push("/Outgoing");
    },
    prevTab() {
      let parameter = {
        step: "7",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "7",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    getData() {
      this.allTeminatedPTW = [];
      this.allLabReport = [];
      this.ptw = [];
      this.ecaf = [];
      this.terminatedptw = [];
      this.labreport = [];

      this.preoperation = [];
      this.duringoperation = [];
      this.postoperation = [];
      this.inspection = [];
      this.other = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.status = response.status.status;
            // weight bridge
            for (var i = 0; i < response.weight_bridge.length; i++) {
              let obj = {
                fileid: response.weight_bridge[i].document_id,
                filename: response.weight_bridge[i].meta.filename,
                fileurl: response.weight_bridge[i].url,
              };
              this.allTeminatedPTW.push(obj);
            }
            // cn
            for (var i = 0; i < response.consignment_note.length; i++) {
              let obj = {
                fileid: response.consignment_note[i].document_id,
                filename: response.consignment_note[i].meta.filename,
                fileurl: response.consignment_note[i].url,
              };
              this.allLabReport.push(obj);
            }

            if (
              this.allTeminatedPTW.length != 0 &&
              this.allLabReport.length != 0
            ) {
              this.dis = false;
            } else {
              this.dis = true;
            }

            this.refno = response.reference_number;
            this.dateselected = moment(response.accepted_at).format(
              "YYYY-MM-DD"
            );
            this.vendorname = response.company_vendor.company_name;
            this.vendorphone = response.company_vendor.phone_number;
            this.platenumber = response.vehicle.vehicle_reg_num;
            this.drivername = response.driver.driver_name;
            this.driveric = response.driver.driver_nric;

            for (var i = 0; i < response.waste_detail.length; i++) {
              let component = [];

              for (
                var j = 0;
                j < response.waste_detail[i].waste_component.length;
                j++
              ) {
                console.log(response.waste_detail[i].waste_component[j]);
                component.push({
                  name: response.waste_detail[i].waste_component[j],
                });
              }
              let obj = {
                wastetypename: response.waste_detail[i].waste_type.name,
                wasteComponents: component,
                estqty: response.waste_detail[i].quantity,
                estqtyunit: response.waste_detail[i].quantity_unit,
                estqtyy: response.waste_detail[i].packaging_quantity,
                estqtyyunit: response.waste_detail[i].packaging.name,
                remarks: response.waste_detail[i].remark,
              };
              this.tableDatas.push(obj);
            }

            // get pre operation photo
            for (var i = 0; i < response.operation_photo.length; i++) {
              if (response.operation_photo[i].index == 0) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.preoperation.push(obj);
              } else if (response.operation_photo[i].index == 1) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.duringoperation.push(obj);
              } else if (response.operation_photo[i].index == 2) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.postoperation.push(obj);
              } else if (response.operation_photo[i].index == 3) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.inspection.push(obj);
              } else if (response.operation_photo[i].index == 4) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.other.push(obj);
              }
            }

            // get PTW doc
            for (var i = 0; i < response.ptw_document.length; i++) {
              let obj = {
                filename: response.ptw_document[i].meta.filename,
                fileurl: response.ptw_document[i].url,
                fileid: response.ptw_document[i].document_id,
              };
              this.ptw.push(obj);
            }

            // get eCAF doc
            for (var i = 0; i < response.ecaf_document.length; i++) {
              let obj = {
                filename: response.ecaf_document[i].meta.filename,
                fileurl: response.ecaf_document[i].url,
                fileid: response.ecaf_document[i].document_id,
              };
              this.ecaf.push(obj);
            }

            // terminated PTW
            for (var i = 0; i < response.terminated_ptw_document.length; i++) {
              let obj = {
                fileid: response.terminated_ptw_document[i].document_id,
                filename: response.terminated_ptw_document[i].meta.filename,
                fileurl: response.terminated_ptw_document[i].url,
              };
              this.terminatedptw.push(obj);
            }
            // lab report
            for (var i = 0; i < response.lab_report.length; i++) {
              let obj = {
                fileid: response.lab_report[i].document_id,
                filename: response.lab_report[i].meta.filename,
                fileurl: response.lab_report[i].url,
              };
              this.labreport.push(obj);
            }
          }
        });
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.getData();
  },
  watch: {
    positionid() {
      console.log(this.positionid);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      console.log(this.status);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    displayflag() {
      console.log(this.displayflag);
    },
  },
};
</script>

<style scoped>
.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}
</style>
